import { render, staticRenderFns } from "./Styled.vue?vue&type=template&id=205eb9c6&"
import script from "./Styled.vue?vue&type=script&lang=js&"
export * from "./Styled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports